<template>
  <div class="service">
    <div :class="className">
      <p><slot name="message"></slot></p>
    </div>
    <div class="text">
      <slot name="text">
      </slot>
    </div>
    <div class="brand">
      <img src="@/assets/brand_hvit.svg" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  },
  computed: {
    className () {
      return `message ${this.color}`
    }
  }
}
</script>

<style>

</style>
